import React from "react";
import { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { TemplateOfferingListingMeetingRoom } from "../template_offering_listing_meeting_room";
import { useRentryAnalytics } from "./rentry_analytics";
import { partnerConfig } from "./rentry_partner_config";

const Theme = lazyWithRetry(() => import("./rentry_theme"));

export function OfferingRentryListingMeetingRoom() {
  useRentryAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingMeetingRoom
        partnerConfig={partnerConfig}
        data={{
          title: "Meeting rooms",
          description:
            "Rentry features a private conference rooms for meetings, equipped with state-of-the-art technology and can accommodate between 2 to 15 people.",
        }}
      />
    </Fragment>
  );
}
